import { Text, View, Switch } from 'react-native';
import React, { FC, useCallback, useMemo, useState } from 'react';
import { FormHelperProps, IFormData } from './FormHelper.types';
import { ErrorMessage, Field, FieldProps, Formik } from 'formik';
import * as yup from 'yup';
import { TextInput } from '../TextInput/TextInput';
import { Button } from '../Button';
import { formHelperStyled } from './FormHelper.styled';
import { STYLE_VARS } from '../../constants/style-vars';
import { useIsDesktop } from '../../hooks/useIsDeskTop';

const FormHelper: FC<FormHelperProps> = ({
  formStructure,
  initValues,
  onSubmit,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  // const [formData, setFormData] = useState<IFormData>({})
  const isDesktop = useIsDesktop();

  const initData: IFormData = useMemo(() => {
    if (initValues) {
      return initValues;
    } else {
      const data = formStructure.components.reduce((data, component) => {
        if (component.type != 'button' && component.type != 'submit') {
          return {
            ...data,
            [component.name]: '',
          };
        } else {
          return {
            ...data,
          };
        }
      }, {});
      return data;
    }
  }, [initValues, formStructure.components]);

  const validationSchema = useMemo(
    () =>
      formStructure.components.reduce(
        (schema, component) => ({
          ...schema,
          [component.name]: component.validation,
        }),
        {}
      ),
    [formStructure.components]
  );

  const yupValidationSchema = useMemo(
    () => yup.object().shape(validationSchema),
    [validationSchema]
  );
  const onSubmitHandler = useCallback(
    async (data: IFormData) => {
      console.log(data);
      if (onSubmit) {
        try {
          setIsLoading(true);
          await onSubmit(data);
          setIsLoading(false);
        } finally {
          setIsLoading(false);
        }
      }
    },
    [onSubmit]
  );

  const renderForm = useCallback(
    (handleSubmit: any) => {
      return formStructure.components.map((component) => {
        switch (component.type) {
          case 'number':
            return <></>;
          case 'button':
            return <></>;
          case 'switch':
            return (
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: 10,
                }}
                key={component.name}
              >
                <Text style={formHelperStyled.formInputLable}>
                  {component.label}
                </Text>
                <Field name={component.name}>
                  {({ field }: FieldProps) => (
                    <Switch
                      trackColor={{
                        // false: STYLE_VARS.primaryColor,
                        true: STYLE_VARS.primaryColor,
                      }}
                      style={{}}
                      thumbColor={
                        // field.value == "true"  ?
                        // STYLE_VARS.fccLightGrey :
                        // 'white'
                        STYLE_VARS.fccLightGrey
                      }
                      onValueChange={(value) => {
                        field.onChange(field.name)(value ? 'true' : 'false');
                      }}
                      value={field.value == 'true' ? true : false}
                    />
                  )}
                </Field>
              </View>
            );
          case 'submit':
            return (
              <View style={{ alignItems: 'center' }} key={component.name}>
                <Button
                  disabled={isLoading}
                  key={component.name}
                  text={component.label || ''}
                  onPress={() => {
                    handleSubmit();
                  }}
                  style={STYLE_VARS.blueButton}
                />
              </View>
            );
          default:
            return (
              <View
                key={component.name}
                style={formHelperStyled.formInputWrapper}
              >
                <Text style={formHelperStyled.formInputLable}>
                  {component.label}
                </Text>
                <Field name={component.name}>
                  {({ field }: FieldProps) => (
                    <View style={{}}>
                      <TextInput
                        placeholder={component.placeholder || 'Input ...'}
                        onChangeText={field.onChange(field.name)}
                        value={field.value}
                        id={field.name}
                        placeholderTextColor={STYLE_VARS.fccDarkGrey}
                        style={formHelperStyled.formInput}
                        secureTextEntry={component.secureTextEntry || false}
                      />
                      <ErrorMessage
                        name={field.name}
                        render={(errorMessage: string) => (
                          <Text style={{ color: 'red' }}>{errorMessage}</Text>
                        )}
                      />
                    </View>
                  )}
                </Field>
              </View>
            );
        }
      });
    },
    [formStructure, isLoading]
  );

  return (
    <Formik
      initialValues={initData}
      onSubmit={onSubmitHandler}
      validationSchema={yupValidationSchema}
      validateOnBlur={true}
    >
      {({ handleSubmit }) => (
        <View
          style={{
            marginVertical: 20,
          }}
        >
          {renderForm(handleSubmit)}
        </View>
      )}
    </Formik>
  );
};

export default FormHelper;
